/**
 * Turn anything that was thrown into an Error with a readable message.
 *
 * Supabase/PostgREST errors are plain objects, not Error instances, so
 * `new Error(String(err))` produced "Error: [object Object]" in Sentry
 * (7792448704) with the real message lost.
 */
export function toError(err: unknown): Error {
  if (err instanceof Error) return err;
  if (typeof err === 'string') return new Error(err);
  if (err && typeof err === 'object') {
    const e = err as { message?: unknown; code?: unknown; details?: unknown; hint?: unknown };
    if (typeof e.message === 'string' && e.message) {
      const extra = [e.code, e.details, e.hint].filter((v) => typeof v === 'string' && v).join(' | ');
      return new Error(extra ? `${e.message} (${extra})` : e.message);
    }
    try {
      return new Error(JSON.stringify(err));
    } catch {
      // circular or otherwise unserialisable
    }
  }
  return new Error(String(err));
}
